
const digest = 'f4718d0b4013e73170f1fb4cc9cd3080551816535ea580dbef2de7018cedbe61';
const classes = {"wrapper":"_wrapper_4xs28_1","content":"_content_4xs28_7"};
const css = `._wrapper_4xs28_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
._wrapper_4xs28_1 ._content_4xs28_7 {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  